import { ATTACHEMENT_MAX_FILE_SIZE_MB } from "../shared/constants"

export const texts_sv = {
    brand: "ArbTask",
    brandDescription: 'Byggd av en trädklättrare, för trädarbete.',

    loginPageHeadline: 'Allt du behöver för trädarbetet.',
    loginPageFeature1: 'Dina jobb på en interaktiv karta',
    loginPageFeature2: 'Professionell offertgenerator',
    loginPageFeature3: 'Kunddatabas',
    loginPageFeature4: 'Lagra foton från arbetsplatsen',
    loginPageFeature5: 'Tidrapporter för ditt team',
    loginPageGetStarted: 'För att komma igång, ange din e-postadress till höger eller logga in med Google eller Facebook. Ny här? Vi skapar ett konto åt dig automatiskt.',
    loginPageMobileGetStarted: 'För att komma igång, ange din e-postadress eller logga in med Google eller Facebook. Ny här? Vi skapar ett konto åt dig automatiskt.',
    loginPageGetStartedEmailOnly: 'För att komma igång, ange din e-postadress till höger. Ny här? Vi skapar ett konto åt dig automatiskt.',
    loginPageMobileGetStartedEmailOnly: 'För att komma igång, ange din e-postadress. Ny här? Vi skapar ett konto åt dig automatiskt.',

    brand_cgh: "CGH",
    brandDescription_cgh: 'Förenkla din serviceverksamhet.',

    defaultError: '💥 Något gick fel. Vänligen försök igen.',
    defaultSuccess: '🎉 Lyckades!',

    poweredByArbTask: 'Drivs av ArbTask',
    delete: 'Ta bort',
    edit: 'Redigera',
    cancel: 'Avbryt',
    save: 'Spara',
    saving: 'Sparar',
    saved: 'Sparad',
    add: 'Lägg till',
    view: 'Visa',
    confirm: 'Bekräfta',
    create: 'Skapa',
    send: 'Skicka',
    confirmation: 'Bekräftelse',
    thisActionCannotBeUndone: 'Denna åtgärd kan inte ångras.',
    attendees: 'Deltagare',
    name: 'Namn',
    account: 'Konto',
    logout: 'Logga ut',
    archive: 'Arkiv',
    archived: 'Arkiverad',
    unarchive: 'Avarkivera',
    preview: 'Förhandsgranska',
    settings: 'Inställningar',
    userPreferences: 'Användarinställningar',
    orgSettings: 'Organisationsinställningar',
    support: 'Support',
    supportDescription: 'Få hjälp med att använda ArbTask',
    contactSupport: 'Kontakta support',
    supportEmailDescription: 'Behöver du hjälp? Har du en fråga? Vi är här för att hjälpa dig att få ut det mesta av ArbTask.',
    emailUs: 'Mejla oss på:',
    responseTime: 'Vi svarar vanligtvis inom 24 timmar under arbetsdagar.',
    frequentlyAskedQuestions: 'Vanliga frågor',
    stillNeedHelp: 'Behöver du fortfarande hjälp?',
    stillNeedHelpDescription: 'Om du inte kan hitta det du letar efter i våra vanliga frågor, tveka inte att höra av dig direkt.',
    supportSendEmail: 'Skicka oss ett mejl',

    // Support FAQs
    faqCreateDealQ: 'Hur skapar jag en ny affär?',
    faqCreateDealA: 'För att skapa en ny affär, navigera till tavelvyn och klicka på knappen \'Ny affär\'. Fyll i kundinformation, plats och relevanta detaljer om trädarbetet som behövs.',
    faqAddTeamMembersQ: 'Hur kan jag lägga till teammedlemmar i min organisation?',
    faqAddTeamMembersA: 'Gå till Organisationsinställningar och klicka på Teamhantering. Du kan bjuda in nya medlemmar genom att ange deras e-postadresser. De kommer att få en inbjudan via e-post att gå med i din organisation.',
    faqAttachFilesQ: 'Hur bifogar jag foton och dokument till affärer?',
    faqAttachFilesA: 'När du tittar på en affär, scrolla ner till bilagssektionen. Du kan dra och släppa filer eller klicka för att bläddra och välja filer. Perfekt för före/efter-foton, tillstånd eller inspektionsrapporter.',
    faqMapViewQ: 'Hur kan jag se trädserviceplatser på en karta?',
    faqMapViewA: 'Använd kartvyn från huvudnavigeringen för att se alla dina affärer plottade geografiskt. Detta hjälper med ruttplanering och förståelse av ditt serviceområde.',
    faqSendEstimatesQ: 'Hur skickar jag offerter till kunder?',
    faqSendEstimatesA: 'Skapa en offert inom en affär, använd sedan delningsfunktionen för att generera en länk som du kan skicka till din kund. De kan se och godkänna offerter utan att behöva ett konto.',

    noData: 'Inget att visa',
    contact: 'Kontakt',
    missing: 'Saknas',
    organizations: 'Organisationer',
    close: 'Stäng',
    thisFieldIsRequired: 'Detta fält är obligatoriskt',

    // Login
    emailSentTo: 'E-post skickad till',
    checkSpamFolder: 'Om du inte ser den, kontrollera din skräppost.',
    newVersionAvailable: 'En ny version finns tillgänglig',
    reload: 'Ladda om',
    loginCodeInstructions: 'Klicka på länken i e-postmeddelandet eller ange koden från det nedan.',
    loginCode: 'Inloggningskod',
    verifyLoginCode: 'Verifiera kod',
    invalidLoginCode: 'Ogiltig eller utgången kod',
    emailAddress: 'E-postadress',
    enterEmail: 'Ange e-post',
    login: 'Logga in',
    acceptInvitation: 'Acceptera inbjudan',
    signUp: 'Registrera dig',
    signInWithGoogle: 'Logga in med Google',
    signInWithFacebook: 'Logga in med Facebook',
    orDivider: 'eller',

    // RUT tax subsidy
    rutTaxSubsidy: 'RUT-avdrag',
    rutDescription: 'Använd 50% skatteavdrag för hushållsnära tjänster (RUT)',
    rutSubsidyAmount: 'RUT-avdrag',
    toPay: 'Att betala',

    // Deals
    pipeline: 'Tavla',
    newDeal: 'Ny affär',
    mapView: 'Kartvy',
    map: 'Karta',
    navigate: 'Navigera',
    deals: 'Affärer',
    deal: 'Affär',
    editPipeline: 'Redigera tavla',
    editPipelineDescription: 'Hantera steg i din säljprocess',
    orphanedDeals: 'Öppnade affärer',
    orphanedDealsDescription: 'Affärer från borttagna pipelinesteg',
    addStep: 'Lägg till steg',
    addStepDescription: 'Lägg till ett nytt steg i din säljprocess',
    newStep: 'Nytt steg',
    removeStep: 'Ta bort steg',
    lastUpdated: 'Senast uppdaterad',
    description: 'Beskrivning',
    address: 'Adress',
    changeLayout: 'Byt layout',
    changeLayoutDescription: 'Byt layout på korten i tavlan',
    updatedAt: 'Senast uppdaterad',
    tags: 'Taggar',
    riskAssessment: 'Riskbedömning',
    riskLevel: 'Risknivå',
    riskLow: 'Låg',
    riskMedium: 'Medel',
    riskHigh: 'Hög',
    riskNotes: 'Anteckningar (valfritt)',
    addRiskAssessment: 'Lägg till bedömning',
    enableRiskAssessment: 'Riskbedömning',
    noRiskAssessments: 'Inga bedömningar registrerade',
    setCompanyAddressToEnableDistanceCalculation: 'Ange företagets adress för att aktivera avståndsberäkning',
    noDeals: 'Inga affärer hittades',

    // Actions
    actions: 'Åtgärder',
    movedFromTo: 'Flyttad från {from} till {to}',
    createdIn: 'Skapad i {step}',
    day: 'dag',
    days: 'dagar',
    hour: 'timme',
    hours: 'timmar',
    minute: 'minut',
    minutes: 'minuter',
    second: 'sekund',
    seconds: 'sekunder',
    beenHere: 'Varit här {time}',
    hasNotBeenHere: 'Har inte varit här',

    // Settings
    accountSettings: 'Kontoinställningar',
    accountSettingsDescription: 'Hantera dina kontoinställningar',
    language: 'Språk',
    languageDescription: 'Välj språk för appen',
    logo: 'Logotyp',
    changeLogo: 'Byt logotyp',
    uploadLogo: 'Ladda upp logotyp',

    // Organization Settings
    organizationSettings: 'Organisationsinställningar',
    organizationSettingsDescription: 'Hantera dina organisationsinställningar',
    headquarterDescription: 'Ange din företagsadress',
    organizationNameDescription: 'Ange ditt företagsnamn',
    organizationEmailDescription: 'Företagets e-post används för meddelanden',
    organizationLogoDescription: 'Ladda upp din företagslogotyp',
    organizationWebsiteDescription: 'Företagets webbplats används för att visa information om din organisation',
    organizationNameRequired: 'Organisationsnamn krävs. Vänligen ange det och spara formuläret.',
    currency: 'Valuta',
    currencyDescription: 'Valuta som används i offerter och prissättning',
    paymentInstructions: 'Betalningsinstruktioner',
    paymentInstructionsDescription: 'Visas på fakturor så att kunder vet hur de ska betala (t.ex. bankgiro, Swish eller referensnummer).',

    // Organization Tabs & Features
    details: 'Detaljer',
    features: 'Funktioner',
    enableHoursTracking: 'Aktivera tidsspårning',

    // Danger Zone
    dangerZone: 'Farozon',
    createNewOrganization: 'Skapa ny organisation',
    createNewOrganizationDescription: 'Skapa en separat ny organisation. Du växlar direkt till den.',
    organizationCreated: 'Organisationen skapades',
    deleteOrganization: 'Ta bort organisation',
    deleteOrganizationDescription: 'Ta bort denna organisation permanent, inklusive alla affärer, kunder, artiklar, utrustning och tidsregistreringar. Detta kan inte ångras.',
    deleteOrganizationWarning: 'Detta kommer permanent att ta bort denna organisation och alla dess affärer, kunder, artiklar, utrustning och tidsregistreringar.',
    deleteOrganizationOwnerOnly: 'Endast organisationens ägare kan ta bort organisationen.',
    organizationDeleted: 'Organisationen togs bort',
    typeNameToConfirm: 'Skriv namnet nedan för att bekräfta:',
    transferOwnership: 'Överför ägarskap',
    transferOwnershipDescription: 'Gör en annan teammedlem till ägare av denna organisation. Du blir en medlem.',
    transferOwnershipOwnerOnly: 'Endast organisationens ägare kan överföra ägarskap.',
    transferOwnershipModalTitle: 'Överför ägarskap',
    transferOwnershipSelectMember: 'Välj medlemmen som ska bli ny ägare',
    transferOwnershipNoEligibleMembers: 'Bjud in en teammedlem innan du överför ägarskap.',
    transferOwnershipWarning: 'Du är på väg att göra {email} till ägare av denna organisation. Du blir en medlem och förlorar åtkomst som endast ägare har, till exempel fakturering och att ta bort organisationen.',
    transferOwnershipConfirmEmail: 'Skriv den nya ägarens e-post nedan för att bekräfta:',
    ownershipTransferred: 'Ägarskapet överfördes',

    // Articles
    articles: 'Artiklar',
    article: 'Artikel',
    newArticle: 'Ny artikel',
    editArticle: 'Redigera artikel',
    price: 'Pris',
    vat: 'Moms',
    searchArticle: 'Sök efter artikel',
    createNewArticle: 'Skapa ny artikel',
    priceWithVat: 'Pris med moms',
    priceWithoutVat: 'Pris utan moms',
    priceWithoutVatPerHour: 'Timpris utan moms',
    articlesDescription: 'Artiklar är varor eller tjänster som kan läggas till i erbjudanden och fakturor.',
    distanceBasedArticle: 'Avståndsbaserad artikel',
    distanceBasedDescription: 'För resekostnader. Denna artikel kommer automatiskt att läggas till i erbjudanden med en kvantitet som motsvarar avståndet i kilometer.',
    isActivityArticle: 'Loggbar aktivitet',
    isActivityArticleDescription: 'Denna artikel representerar en aktivitet som kan loggas i tidrapporter, prissatt per timme.',

    // Equipment
    equipment: 'Utrustning',
    equipmentDescription: 'Spåra verktyg och utrustning som ägs av din organisation.',
    newEquipment: 'Ny utrustning',
    editEquipment: 'Redigera utrustning',
    equipmentCategory: 'Kategori',
    equipmentMake: 'Märke',
    equipmentModel: 'Modell',
    equipmentSerialNumber: 'Serienummer',
    equipmentPurchaseDate: 'Inköpsdatum',
    equipmentPurchasePrice: 'Inköpspris',
    equipmentCurrentValue: 'Nuvarande värde',
    equipmentNotes: 'Anteckningar',
    equipmentTotalPurchaseValue: 'Totalt inköpsvärde',
    equipmentTotalCurrentValue: 'Totalt nuvarande värde',
    equipmentCategoryChainsaw: 'Motorsåg',
    equipmentCategoryClimbingGear: 'Klätterutrustning',
    equipmentCategoryTruck: 'Lastbil',
    equipmentCategoryChipper: 'Flismaskin',
    equipmentCategoryRigging: 'Riggning',
    equipmentCategoryHandTools: 'Handverktyg',
    equipmentCategoryOther: 'Övrigt',

    // TimeSheets
    timesheets: 'Tidrapporter',
    tuesday: 'Tis',
    wednesday: 'Ons',
    thursday: 'Tors',
    friday: 'Fre',
    saturday: 'Lör',
    perDay: 'Per dag',
    perWeek: 'Per vecka',
    week: 'Vecka',
    weekShort: 'v',
    totalHours: 'Totala timmar',
    newTimesheetEntry: 'Ny tidrapport',
    trackedTime: 'Registrerad tid',
    addTime: 'Lägg till tid',
    startWorking: 'Börja jobba',
    stopWorking: 'Sluta jobba',
    workingSince: 'Jobbat sedan',
    start: 'Start',
    end: 'Slut',
    totalTimeHoursMinutes: 'Total tid (timmar : minuter)',
    notes: 'Anteckningar',
    viewTimeline: 'Visa tidslinje',
    required: 'Obligatoriskt',
    seeDealTimeLine: 'Se affärens tidslinje',
    timeline: 'Affärens tidslinje',
    timeRecords: 'Tidsregistreringar',
    endDateAfterStartDate: 'Slutdatumet ska vara efter startdatumet',
    hoursTracked: 'Spårade timmar',
    dealDetails: 'Affärsdetaljer',
    deleteTimeRecord: 'Är du säker på att du vill ta bort denna tidsregistrering?',
    exportCsv: 'Exportera CSV',

    // Invoices
    invoices: 'Fakturor',
    invoice: 'Faktura',
    createInvoice: 'Skapa faktura',
    partialInvoice: 'Delfaktura',
    invoiceCreated: 'Faktura skapad',
    invoiceStatusDraft: 'Utkast',
    invoiceStatusSent: 'Skickad',
    invoiceStatusPaid: 'Betald',
    invoiceStatusCancelled: 'Makulerad',
    period: 'Period',
    sendInvoice: 'Skicka faktura',
    sendInvoiceDescription: 'Skicka en faktura till en kund som en skrivskyddad länk.',
    shareInvoiceMailto: "Hej {customerName},\n\nDu kan se fakturan här:\n{link}\n\nMed vänliga hälsningar,\n{organizationName}",
    shareInvoiceMailtoSubject: "Ny faktura från {organizationName}",
    shareInvoiceSms: "Hej {customerName}, du kan se fakturan från {organizationName} här: {link}",

    // Activities
    activity: 'Aktivitet',
    splitHoursByActivity: 'Fördela timmar per aktivitet',
    fillRemaining: 'Fyll i resten',
    assignedHours: 'Fördelat',
    remainingHours: 'Återstår',
    activitySplitMismatch: 'Timmarna som fördelats på aktiviteter måste summera till den totala tiden.',
    groupBy: 'Gruppera efter',
    unassignedActivity: 'Ingen aktivitet',

    // Search
    search: 'Sök',
    noResults: 'Inga resultat hittades',

    // Offers
    offer: 'Erbjudande',
    offers: 'Erbjudanden',
    offersDescription: 'Hantera dina erbjudanden',
    comingSoon: 'Kommer snart',
    editDeal: 'Redigera affär',
    newOffer: 'Nytt erbjudande',
    offerCreated: 'Erbjudande har skapats',
    acceptedOffer: 'Accepterat erbjudande',
    offerOpenedByCustomer: 'Erbjudandet öppnat av kunden',
    offerAccepted: 'Erbjudandet accepterat av kunden',
    customerLeftComment: 'Kunden lämnade en kommentar',
    acceptOffer: 'Acceptera erbjudande',
    comment: 'Kommentar',
    latestOffer: 'Senaste erbjudande',
    manageOffers: 'Hantera erbjudanden',
    pending: 'Väntande',
    saveAsTemplate: 'Spara som mall',
    noLocationSet: 'Ingen plats angiven',
    useCurrentLocation: 'Använd nuvarande plats',
    gettingLocation: 'Hämtar plats...',
    pickOnMap: 'Välj på karta',
    useThisLocation: 'Använd denna plats?',
    locationPermissionDenied: 'Platstillstånd nekades',
    locationNotSupported: 'Plats stöds inte av din webbläsare',
    locationError: 'Kunde inte hämta din plats',
    noOffer: 'Inget erbjudande',

    // Attachements
    attachments: 'Bilagor',
    addAttachment: 'Lägg till bilaga',
    photos: 'Foton',
    dragImagesHere: 'Dra bilder hit eller klicka för att välja',
    browseFiles: 'Bläddra bland filer',
    fileSizeTooLarge: `Filstorleken är för stor ({size} MB). Max ${ATTACHEMENT_MAX_FILE_SIZE_MB} MB tillåtet.`,
    deleteAttachement: 'Ta bort bilaga',
    dropFileHere: 'Släpp filen här',
    takePhoto: 'Ta foto',
    noAttachments: 'Inga bilagor tillgängliga',
    download: 'Ladda ner',

    // Customers
    customer: 'Kund',
    customers: 'Kunder',
    person: 'Person',
    company: 'Företag',
    firstName: 'Förnamn',
    lastName: 'Efternamn',
    phone: 'Telefon',
    email: 'E-post',
    website: 'Webbplats',
    personalNumber: 'Personnummer',
    personalNumberShort: 'PN', // Personnummer förkortning
    organizationNumber: 'Organisationsnummer',
    newCustomer: 'Ny kund',
    editCustomer: 'Redigera kund',
    note: 'Notering',
    searchCustomer: 'Sök kund',
    pressEnterToCreateNewCustomer: 'Tryck på enter för att skapa <b>ny kund</b>',
    changeCustomer: 'Byt kund',

    // Filters
    filters: 'Filter',
    clear: 'Rensa',
    step: 'Steg',

    // Due Date
    dueDate: 'Förfallodatum',
    addDueDate: 'Lägg till förfallodatum',

    // Team
    team: 'Team',
    teamDescription: 'Hantera ditt teams medlemmar',
    addMember: 'Lägg till Medlem',
    inviteMember: 'Bjud in en teammedlem',
    enterEmails: 'Ange e-postadresser separerade med kommatecken',
    invalidEmails: 'Vänligen ange giltiga e-postadresser.',
    role: 'Roll',
    status: 'Status',
    invitationsCreated: 'Inbjudningar skapades.',
    manager: 'Manager',
    worker: 'Arbetare',
    memberDescription: 'Kan se alla jobb och hantera dem',
    workerDescription: 'Kan bara se jobb som tilldelats dem',
    sendingInvitation: 'Skickar inbjudan',
    invitationSent: 'Inbjudan skickad',
    accepted: 'Accepterad',
    viewed: 'Visad',
    copyInvitationLink: 'Kopiera inbjudningslänk',
    invitationLinkCopied: 'Inbjudningslänk kopierad till urklipp',
    changeRole: 'Ändra roll',
    changeRoleModalTitle: 'Ändra medlemsroll',
    changeRoleDelayWarning: 'Det kan ta upp till en timme innan den nya rollen börjar gälla, eller tills medlemmen loggar ut och in igen.',
    roleUpdated: 'Rollen har uppdaterats',
    paused: 'Pausad',
    pauseMember: 'Pausa medlem',
    reactivateMember: 'Återaktivera medlem',
    memberPaused: 'Medlem pausad',
    memberReactivated: 'Medlem återaktiverad',
    admin: 'Admin',

    // Share
    share: 'Dela',
    shareDeal: 'Dela affär',
    shareDescription: 'Dela en affär med extern användare',
    linkCoppied: 'Länk kopierad till urklipp',
    readonly: 'Skrivskyddad',

    // Not found
    notFound: '404 - Hittades inte',
    notFoundDescription: 'Det här är inte träden du letar efter.',

    // Background Color
    backgroundColor: "Bakgrundsfärg",
    chooseColor: "Välj färg",

    // Block Types
    textBlock: "Text",
    imageBlock: "Bild",
    headingBlock: "Rubrik",
    lineBlock: "Linje",
    organizationCustomerBlock: "Organisation & Kund",

    // Organization/Customer Block
    organization: "Organisation",
    seller: "Säljare",
    editOrganization: "Redigera organisation",
    noCustomer: "Ingen kund vald",
    noName: "Namnlös",
    addRow: "Lägg till rad",

    // Line items table
    quantity: "Antal",
    total: "Totalt",
    moveUp: "Flytta upp",
    moveDown: "Flytta ner",
    deleteRow: "Ta bort rad",
    excludingVat: "Exklusive moms",
    addDiscount: 'Lägg till rabatt',
    discount: 'Rabatt',

    sendOffer: "Skicka erbjudande",
    sendOfferDescription: "Skicka ett erbjudande till en kund. Du kommer att meddelas när kunden öppnar erbjudandet.",
    shareOfferMailto: "Hej {customerName},\n\nDu kan visa erbjudandet här:\n{link}\n\nMed vänliga hälsningar,\n{organizationName}",
    shareOfferMailtoSubject: "Nytt erbjudande från {organizationName}",
    shareOfferSms: "Hej {customerName}, du kan visa erbjudandet från {organizationName} här: {link}",
    sendEmail: "Skicka e-post",
    sendSMS: "Skicka SMS",

    // Tree service texts
    treeServiceDescription: "Vi på vårt företag sätter stolthet i att leverera skräddarsydda trädvårdstjänster av högsta kvalitet. Med vår erfarna personal och professionella tillvägagångssätt säkerställer vi att dina träd hålls friska, säkra och vackra året runt. Vi förstår vikten av detaljerad planering och noggrant utförande för varje uppdrag.",
    treeServiceThankYou: "Tack för att ni överväger oss för era trädvårdsbehov.",

    // Integrations
    integrations: 'Integrationer',
    integrationsDescription: 'Anslut din organisation till externa tjänster för att förbättra funktionaliteten',
    customerForm: 'Kundformulär',
    customerFormDescription: 'Använd detta formulär för att låta kunder skapa affärer direkt i din organisation för att undvika manuell datainmatning.',
    customerFormHint: 'Använd länken för att ersätta kontaktformulär på din webbplats eller sociala medier.',
    customerFormLanguage: 'Formulärspråk',
    customerFormLanguageDescription: 'Språket kunder ser när de öppnar formuläret.',
    customerFormIntroLabel: 'Rubrik',
    customerFormIntroDescription: 'Visas högst upp i formuläret. Lämna tomt för att använda standardtexten.',
    customerFormThankYouLabel: 'Tackmeddelande',
    customerFormThankYouDescription: 'Visas för kunder efter att de skickat in formuläret. Lämna tomt för att använda standardtexten.',
    accounting: 'Redovisning',
    fortnoxConnected: 'Fortnox är anslutet.',
    fortnoxDescription: 'Anslut ditt Fortnox-konto för att synkronisera kunder och artiklar.',
    connectFortnox: 'Anslut Fortnox',
    failedToConnectFortnox: 'Det gick inte att ansluta Fortnox',
    failedToInitiateFortnoxConnection: 'Det gick inte att starta Fortnox-anslutningen',
    syncCustomers: 'Synkronisera kunder',
    failedToSyncCustomers: 'Det gick inte att synkronisera kunder',
    syncCustomersResult: 'Synk klar: {imported} importerade, {linked} länkade, {pushed} skickade till Fortnox.',
    tellUseAboutYourProject: "Berätta om ditt projekt",

    // Members
    members: 'Medlemmar',
    allMembers: 'Alla medlemmar',
    noMembersAssigned: 'Inga medlemmar tilldelade',

    // Comments
    comments: 'Kommentarer',
    noComments: 'Inga kommentarer än',
    writeComment: 'Skriv en kommentar...',
    addComment: 'Lägg till kommentar',

    // Avatar
    changeAvatar: 'Byt avatar',
    avatarLinkedToGravatar: 'Denna avatar är kopplad till {email} via Gravatar.',
    avatarUpdateTime: 'Det kan ta några minuter innan den nya avataren visas här efter att du ändrat den på Gravatar.',

    // Billing page copy
    billing: 'Fakturering',
    billingDescription: 'Hantera din prenumeration och se tillgängliga planer.',
    plan: 'Plan',
    currentPlan: 'Nuvarande plan',
    availablePlans: 'Välj den plan som passar din arbetsbelastning',
    dealsPerMonth: 'Affärer per månad',
    upgrade: 'Uppgradera',
    free: 'Gratis',
    base: 'Bas',
    selectPlan: 'Välj plan',
    current: 'Nuvarande',
    billingHeading: 'Enkel, rättvis prissättning som växer med ditt arbete',
    billingIntro1: 'Betala bara för de jobb du aktivt hanterar - inte antalet användare i ditt team.',
    billingIntro2: 'Bjud in hela ditt team, hantera obegränsade kunder och skala din plan i takt med att arbetsbelastningen ökar.',
    billingFeature1: 'Obegränsat antal teammedlemmar',
    billingFeature2: 'Betala bara för aktiva jobb',
    billingFeature3: 'Uppgradera eller nedgradera när som helst',
    billingWhyTitle: 'Varför ArbTask prissättning fungerar för trädvårdsföretag',
    billingWhyPara1: 'Trädvårdsarbete är säsongsbetonat. Vissa månader är fullbelagda, andra lugnare.',
    billingWhyPara2: 'ArbTask prissättning är utformad så att du bara betalar för det arbete du faktiskt hanterar.',
    billingWhyBullet1: 'Rättvist för säsongsbetonade företag - prissättningen anpassas efter din arbetsbelastning',
    billingWhyBullet2: 'Obegränsat antal teammedlemmar - lägg till hela ditt team utan extra avgifter',
    billingWhyBullet3: 'Arkivera avslutade jobb när som helst – frigör utrymme direkt',
    billingWhyBullet4: 'Skala upp eller ner enkelt – byt plan när som helst',
    billingFooter1: 'Du kan arkivera avslutade jobb när som helst för att frigöra aktiva platser.',
    billingFooter2: 'Inga kontrakt. Inga avgifter per användare.',
    trialActive: 'Testperiod aktiv',
    trialActiveUntil: 'obegränsat antal jobb till och med',
    unlimited: 'Obeg.',
    activeDeals: 'aktiva affärer',
    billedMonthly: 'Faktureras månadsvis',
    billedAnnually: 'Faktureras årsvis',
    perMonth: '/mån',
    perYear: '/år',
    dealLimitReached: 'Du har nått gränsen för aktiva affärer för din nuvarande plan. Vänligen arkivera avslutade jobb eller uppgradera din plan för att lägga till fler aktiva affärer.',
    dealLimitReachedNative: 'Du har nått gränsen för aktiva affärer för din nuvarande plan. Arkivera avslutade jobb för att lägga till fler aktiva affärer.',
    usageSectionHeader: 'Din nuvarande användning',
    usageSectionDescription: 'Detta visar hur många aktiva affärer du för närvarande använder av din plangräns. Arkivera avslutade jobb för att frigöra platser.',

    // Plan cards
    planTagLine0: 'Passar bäst för små team som precis börjat',
    planTagLine1: 'Passar bäst för små växande team',
    planTagLine2: 'Passar bäst för etablerade trädvårdsföretag',
    planTagLine3: 'Passar bäst för stora verksamheter',
    planTagLineUnder0: 'Passar bäst för små team som precis börjat',
    planTagLineUnder1: 'Hantera många projekt utan att nå gränsen.',
    planTagLineUnder2: 'Utformad för företag som hanterar många team och aktiva projekt.',
    planTagLineUnder3: 'Kör hela din verksamhet utan begränsningar.',
    planBenefit00: 'Obegränsat antal användare',
    planBenefit01: 'Klientuppföljning',
    planBenefit10: 'Allt i Gratis',
    planBenefit11: 'Hantera upp till 30 aktiva jobb',
    planBenefit20: 'Allt i Starter',
    planBenefit21: 'Hantera upp till 100 aktiva jobb',
    planBenefit30: 'Allt i Growth',
    planBenefit31: 'Obegränsat antal aktiva jobb',
}
